var _style, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000152248332968429545790000001398234482401108632_);}\r\n\t.st2{fill:url(#SVGID_00000156559847166033694180000016262667274631556995_);}\r\n\t.st3{fill:url(#SVGID_00000070834803260678324910000000326198681468906920_);}\r\n\t.st4{fill:url(#SVGID_00000096745218070106866150000005740128583844325790_);}\r\n\t.st5{fill:url(#SVGID_00000075841525697765070080000009210935359730493629_);}\r\n\t.st6{fill:url(#SVGID_00000029752213420615701650000016763374787638501561_);}\r\n\t.st7{fill:url(#SVGID_00000040551858706196744940000003789812674203242387_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 767.085,
    cy: 541,
    r: 402.9105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E9FE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B6297"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "839.4,0 588.2,0 916.5,1082 946,1082  "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000169554883048822361990000014441862266703344008_",
    cx: 410.26,
    cy: 745.5,
    r: 375.0494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E9FE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B6297"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000169554883048822361990000014441862266703344008_)"
    },
    points: "0.3,675.8 760.2,1082 820.2,1082  0.3,409  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000132784532441502832080000000560113936964502451_",
    cx: 441.725,
    cy: 541,
    r: 493.7426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E9FE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B6297"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000132784532441502832080000000560113936964502451_)"
    },
    points: "0.3,38.3 856.8,1082 883.2,1082  304.9,0 0.3,0  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000007403975734440327760000014791244674482681769_",
    cx: 314.65,
    cy: 986.635,
    r: 232.3029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E9FE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B6297"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000007403975734440327760000014791244674482681769_)"
    },
    points: "629,1082 0.3,891.3 0.3,1082  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000171699877239443266350000012038184111968384926_",
    cx: 1510.01,
    cy: 745.5,
    r: 375.0493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E9FE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B6297"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000171699877239443266350000012038184111968384926_)"
    },
    points: "1160,1082 1920,675.8 1920,409  1100,1082  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000173842576584860434880000004527291673699614602_",
    cx: 1478.5449,
    cy: 541,
    r: 493.7426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E9FE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B6297"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000173842576584860434880000004527291673699614602_)"
    },
    points: "1037.1,1082 1063.4,1082  1920,38.2 1920,0 1615.4,0  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000163073418641060774640000010517880825716026010_",
    cx: 1605.62,
    cy: 986.635,
    r: 232.3029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E9FE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B6297"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000163073418641060774640000010517880825716026010_)"
    },
    points: "1920,1082 1920,891.3  1291.2,1082  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000075846607877988926870000003487566469114778793_",
    cx: 1153.1851,
    cy: 541,
    r: 402.9105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E9FE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B6297"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000075846607877988926870000003487566469114778793_)"
    },
    points: "1080.9,0 974.3,1082 1003.8,1082  1332.1,0  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.210af20adf3ea91e1a629d8cd3ba5805.svg";
export { ForwardRef as ReactComponent };